var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',{class:_vm.$style.tbody},_vm._l((_vm.data),function(item,key){return _c(_vm.to ? 'BaseLink' : 'tr',{key:("body" + key),tag:"component",attrs:{"to":_vm.getTo(item),"tag":"tr"}},[_vm._t("default",null,{"item":item})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }